/**
 * The phone app bar's ← back button (snippets/custom-header-back.liquid).
 *
 * Back to the previous page when it is this store — the browser restores it
 * from its back-forward cache, so it is instant and keeps the scroll position.
 * Opened from outside (a shared link, a search result) there is nothing of ours
 * to go back to, so the plain link opens Home instead.
 */
class BackLink extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  /** @param {MouseEvent} event */
  #onClick = (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }
    if (!cameFromThisStore()) return; // follow the link: Home

    event.preventDefault();
    history.back();
  };
}

function cameFromThisStore() {
  if (history.length < 2 || !document.referrer) return false;
  try {
    return new URL(document.referrer).origin === location.origin;
  } catch {
    return false;
  }
}

if (!customElements.get('q-back-link')) {
  customElements.define('q-back-link', BackLink);
}
